export const serviceDescription = [
    {
        key : "Landing",
        image : "./images/landing_page.png",
        image_alt : "service-Landing",
        service_english : "Landing page",
        title_english : "Your Stunning Digital Business Card", 
        service_description_english : "Impress visitors with a digital business card that connects contact info and social media.",
        service_french : "Landing page/Page web",
        title_french : "Votre superbe carte de visite numérique", 
        service_description_french : "Impressionnez les visiteurs avec une carte de visite numérique qui relie les informations de contact et les réseaux sociaux.",
        service_arabic : "Landing page/صفحة هبوط", 
        title_arabic : "بطاقتك الرقمية الرائعة", 
        description_arabic : "قم بإنشاء بطاقات العمل الرقمية الخاصة بك الآن",
        service_description_arabic : "إبهر الزوار ببطاقة أعمال رقمية تربط معلومات الاتصال ووسائل التواصل الاجتماعي.",
    },{
        key : "Portfolio/Business",
        image : "./images/business_website.jpg",
        image_alt : "service-Business",
        service_english : "Portfolio/Business Website",
        title_english : "Your Business Name's Marketing-Optimized Website", 
        service_description_english : "Your website is a 24/7 marketing powerhouse, driving conversions and boosting your brand's success.",
        service_french : "Site web Portfolio/Entreprise",
        title_french : "Mettez en valeur votre créativité, allumez votre présence en ligne", 
        service_description_french : "Votre site web est une machine marketing 24/7, générant des conversions et renforçant le succès de votre marque.",
        // service_arabic : "موقع Portfolio للأشخاص/موقع للشركات",
        service_arabic : "موقع للحرفيين/الشركات",
        title_arabic : "عرض إبداعك، وشعِّل وجودك على الإنترنت", 
        service_description_arabic : "موقع الويب الخاص بك هو قوة تسويقية على مدار الساعة، تدفع التحويلات وتعزز نجاح علامتك التجارية.",
    },{
        key : "Blog",
        image : "./images/blog_website.png",
        image_alt : "service-Blog",
        service_english : "Blog Website", 
        title_english : "Your Personal Journey, Shared with the World", 
        service_description_english : "Transform your thoughts and passions into a strong online presence. Your blog as an influencer is your canvas for impact.",
        service_french : "Site web de blogging", 
        title_french : "Votre parcours personnel, partagé avec le monde", 
        service_description_french : "Transformez vos idées et passions en une forte présence en ligne. Votre blog en tant qu'influenceur est votre toile pour avoir de l'impact.",
        service_arabic : "موقع ويب للمدونة", 
        title_arabic : "رحلتك الشخصية، مشاركة مع العالم", 
        service_description_arabic : "حوّل أفكارك وشغفك إلى وجود قوي عبر الإنترنت. مدونتك كمؤثر هي لوحتك للتأثير.",
    },{
        key : "Ecommerce",
        image : "./images/ecommerce_website.png",
        image_alt : "service-Ecommerce",
        service_english : "E-commerce Website",
        title_english : "Let Your Customers Shop Your Way to Convenience and Style", 
        service_description_english : "Enhance client online shopping with a versatile e-commerce platform, offering a wide product range and secure payment options.",
        service_french : "Site web E-commerce",
        title_french : "Permettez à vos clients de faire leurs achats à leur manière, en toute commodité et avec style", 
        service_description_french : "Améliorez les achats en ligne pour vos clients grâce à une plateforme e-commerce polyvalente, proposant une vaste gamme de produits et des options de paiement sécurisées.",
        service_arabic : "موقع للتجارة الإلكترونية",
        title_arabic : "دع عملائك يتسوقون بالطريقة التي يفضلونها بسهولة وأناقة", 
        service_description_arabic : "قم بتعزيز تجربة التسوق عبر الإنترنت للعملاء باستخدام منصة التجارة الإلكترونية متعددة الاستخدامات، تقدم مجموعة واسعة من المنتجات وخيارات دفع آمنة.",
    },{
        key : "Educational",
        image : "./images/educational_website.png",
        image_alt : "service-Educational",
        // service_english : "Educational Website (e-learning platform, school management)",
        service_english : "Educational Website",
        title_english : "Empower Minds, Shape Futures", 
        service_description_english : "Passionate about education? Inspire learners with online courses, tutorials, and valuable resources for thriving in the digital age.",
        // service_french : "Site web éducatif (e-learning plateforme, gestion scolaire)",
        service_french : "Site web éducatif",
        title_french : "Autonomisez les esprits, façonnez l'avenir", 
        service_description_french : "Passionné par l'éducation ? Inspirez les apprenants avec des cours en ligne, des tutoriels et des ressources précieuses pour prospérer à l'ère numérique.",
        // service_arabic : "موقع تعليمي (منصة تعلم إلكتروني، إدارة المدرسة)",
        service_arabic : "موقع تعليمي",
        title_arabic : "قوِّي العقول، وعَقِّب المستقبل", 
        service_description_arabic : "ملتزمون بالتعليم؟ قم بإلهام المتعلمين من خلال دورات عبر الإنترنت والدروس التعليمية والموارد القيمة للنجاح في العصر الرقمي.",
    },{
        key : "Application",
        image : "./images/app_website.png",
        image_alt : "service-Application",
        service_english : "Web Application",
        title_english : "Crafting Complexity, Delivering Simplicity", 
        service_description_english : "Your vision, my expertise. Craft web apps to simplify tasks and enhance success.",
        service_french : "Application web",
        title_french : "Créer la complexité, offrir la simplicité", 
        service_description_french : "Votre vision, mon expertise. Concevez des applications web pour simplifier les tâches et renforcer la réussite.",
        service_arabic : "تطبيق ويب",
        title_arabic : "صناعة التعقيد، تقديم البساطة", 
        service_description_arabic : "رؤيتك، خبرتي. صمم تطبيقات الويب لتبسيط المهام وزيادة النجاح.",
    },{
        key : "Mobile",
        image : "./images/mobile_app.png",
        image_alt : "service-Mobile",
        service_english : "Mobile Application",
        title_english : "Inspiring Innovation, Delivering Mobility", 
        service_description_english : "Elevate your brand with custom iOS and Android apps. I create sleek, user-friendly apps for startups and growth.",
        service_french : "Application Mobile",
        title_french : "Inspirant l'Innovation, Offrant la Mobilité",
        service_description_french : "Rehaussez votre marque avec des applications iOS et Android sur mesure. Je crée des applications élégantes et conviviales pour les startups et la croissance.",
        service_arabic : "برمجة الهواتف",
        title_arabic : "إلهام الابتكار، توفير التنقل", 
        service_description_arabic : "قم بترقية علامتك التجارية باستخدام تطبيقات iOS و Android مخصصة. أنشئ تطبيقات أنيقة وسهلة الاستخدام للشركات الناشئة ولتحقيق النمو.",
    },{
        key : "Plugin",
        image : "./images/wordpress_plugin.png",
        image_alt : "service-Wordpress",
        service_english : "WordPress Plugin Creation",
        title_english : "Enhance Your WordPress Universe", 
        service_description_english : "Supercharge your website with cutting-edge WordPress plugins.",
        service_french : "Creation Plugin WordPress",
        service_description_french : "Boostez votre site web avec des plugins WordPress Personalisés.",
        service_arabic : "إنشاء إضافة ووردبريس (Plugin)",
        title_arabic : "قم بتعزيز عالم ووردبريس الخاص بك", 
        service_description_arabic : "قم بتعزيز موقع الويب الخاص بك بواسطة مكونات إضافية WordPress الرائدة.",
    },{
        key : "Maintenance",
        image : "./images/maintenance.png",
        image_alt : "service-Maintenance",
        service_english : "Website Maintenance",
        title_english : "Stay Ahead with Effortless Website Care", 
        service_description_english : "Fixing website issues for seamless success!",
        service_bug_stacks_english : "My main stacks are Javascript, Reactjs, React Native, PHP, Laravel and JAVA",
        service_french : "Maintenance site web",
        title_french : "Gardez une longueur d'avance grâce à une gestion de site web sans effort", 
        service_description_french : "Réparation de problèmes de site web pour un succès ininterrompu !",
        service_bug_stacks_fernch: "Mes principales compétences sont les suivantes : Javascript, Reactjs, React Native, PHP, Laravel and JAVA",
        service_arabic : "صيانة الموقع الإلكتروني",
        title_arabic : "كن دائمًا في الصدارة مع الرعاية السهلة للموقع الإلكتروني", 
        service_description_arabic : "إصلاح مشاكل الموقع لتحقيق النجاح السلس!",
        service_bug_stacks_arabic : "أبرز التقنيات التي أتقنها: Javascript, Reactjs, React Native, PHP, Laravel and JAVA",
    },
]